<template>
  <div class="DeparmentsView">
    <PageHeader title="Wirtualne Działy"
                :description-in-modal="true"
                @openDescriptionModal="hintModalVisible = !hintModalVisible"
    />
    <ShPageLayout>
      <DepartmentsList :agents-list="agentsList" />
    </ShPageLayout>
    <ShSideBarModal title="Nowy Wirtualny Dział"
                    :width="1280"
                    :side-bar-modal-visibility.sync="isModalWithCreateNewDepartmentVisible"
    >
      <CreateDepartmentForm slot="content"
                            :agents-list="agentsList"
                            @closeModal="isModalWithCreateNewDepartmentVisible = false"
      />
    </ShSideBarModal>
    <ShSideBarModal title="Edycja wygląd Wirtualnego Działu"
                    :side-bar-modal-visibility.sync="isModalWithDepartmentNameAndSymbolFormVisible"
    >
      <DepartmentNameAndSymbolForm slot="content"
                                   :department="department"
                                   @closeModal="isModalWithDepartmentNameAndSymbolFormVisible = false"
      />
    </ShSideBarModal>
    <ShSideBarModal title="Edycja listy konsutlantów w Wirtualnym Dziale"
                    :side-bar-modal-visibility.sync="isModalWithDepartmentAssignedAgentsFormVisible"
    >
      <DepartmentAssignedAgentsForm slot="content"
                                    :department="department"
                                    :agents-list="agentsList"
                                    @closeModal="isModalWithDepartmentAssignedAgentsFormVisible = false"
      />
    </ShSideBarModal>
    <ShModalWindow v-if="hintModalVisible"
                   @closeModal="hintModalVisible = !hintModalVisible"
    >
      <template #header>
        <img style="margin-right:10px"
             :src="require('@/assets/images/ikona-wirtualne-dzialy.png')"
        >
        Wirtualne Działy
      </template>
      <template #description>
        <PopupHints hint-template-name="departments" />
      </template>
    </ShModalWindow>
  </div>
</template>

<script>
import { PopupHintsUtils } from '@/mixins';
import ShPageLayout from '@/components/Helpers/ShPageLayout';
import ShSideBarModal from '@/components/Helpers/ShSideBarModal';
import ShModalWindow from '@/components/Helpers/ShModalWindow';
import PageHeader from '@/components/Common/PageHeader';
import PopupHints from '@/components/Common/PopupHints';
import DepartmentsList from '@/components/Departments/DepartmentsList';
import CreateDepartmentForm from '@/components/Departments/CreateDepartmentForm';
import DepartmentNameAndSymbolForm from '@/components/Departments/DepartmentNameAndSymbolForm';
import DepartmentAssignedAgentsForm from '@/components/Departments/DepartmentAssignedAgentsForm';

export default {
  name: 'Deparments',
  components: {
    PageHeader,
    ShPageLayout,
    ShSideBarModal,
    ShModalWindow,
    PopupHints,
    DepartmentsList,
    CreateDepartmentForm,
    DepartmentNameAndSymbolForm,
    DepartmentAssignedAgentsForm,
  },

  mixins: [PopupHintsUtils],

  data() {
    return {
      isModalWithCreateNewDepartmentVisible: false,
      isModalWithDepartmentNameAndSymbolFormVisible: false,
      isModalWithDepartmentAssignedAgentsFormVisible: false,
      department: null,
    };
  },

  computed: {
    agentsList() {
      return this.$store.getters['agents/list'];
    },
  },

  created() {
    this.mCheckInLocalStorageIfModalHasBeenAlreadyShown('departmentsModalOpen');
    this.$store.dispatch('agents/getList');
    this.$EventBus.$on('DepartmentsList/CREATE_NEW_DEPARTMENT', () => {
      this.isModalWithCreateNewDepartmentVisible = true;
    });
    this.$EventBus.$on('DepartmentsListItem/EDIT_DEPARTMENT', (department) => {
      this.department = department;
      this.isModalWithDepartmentNameAndSymbolFormVisible = true;
    });
    this.$EventBus.$on('DepartmentsListItem/EDIT_ASSIGMENT_OF_AGENTS', (department) => {
      this.department = department;
      this.isModalWithDepartmentAssignedAgentsFormVisible = true;
    });
  },
  beforeDestroy() {
    this.$EventBus.$off('DepartmentsList/CREATE_NEW_DEPARTMENT');
    this.$EventBus.$off('DepartmentsListItem/EDIT_DEPARTMENT');
    this.$EventBus.$off('DepartmentsListItem/EDIT_ASSIGMENT_OF_AGENTS');
  },
};
</script>
<style lang="sass">
.image
  background-size: cover
  border-radius: 10px
  height: 100%
  width: 100%
</style>
